const VERSION_CHECK_INTERVAL = 1 * 60 * 1000 // 5 minutes

let intervalId = null

export function startVersionCheck() {
  if (intervalId) return

  const buildVersion = process.env.VUE_APP_VERSION
  if (!buildVersion) return

  intervalId = setInterval(async () => {
    try {
      const res = await fetch("/version.json?t=" + Date.now())
      if (!res.ok) return

      const { version } = await res.json()
      if (version && version !== buildVersion) {
        console.log(`New version detected (${buildVersion} → ${version}). Reloading…`)
        clearInterval(intervalId)
        window.location.reload()
      }
    } catch {
      // Network error — ignore
    }
  }, VERSION_CHECK_INTERVAL)
}
